// Use PostgreSQL query (not AWS Amplify query)
import {listWorkspaces as listWorkspacesGraphQL} from '../../../graphql/queries';
import {queryGqlApi} from "../../../graphql/queryGqlApi";
import { IDataClientService } from '../../../platform/services/data/DataClientService';
import { IAuthService } from '../../../platform/services/auth/AuthService';


export const listWorkspaces = (
    dataClientService: IDataClientService,
    authService: IAuthService,
    nextToken?: string, 
    limit?: number
): Promise<any> => {
    return queryGqlApi(
        listWorkspacesGraphQL,
        {
            limit: limit,
            nextToken: nextToken
        },
        dataClientService,
        authService,
        'pgServer'
    );
}
